import Vue from 'vue'
import moment from 'moment'

Vue.filter('showDate', (date, format = 'DD-MM-YYYY') => {
  const dateTime = new Date(date)
  return moment(dateTime).format(format)
})

Vue.filter('showFullPriceFormat', (number = 0) => {
  const str = parseFloat(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return str
})

export default Vue



// WEBPACK FOOTER //
// ./src/utils/filter.js